import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row col-md-12 p-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "row col-md-12"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-pencil col-md-1 text-primary",
  style: {"font-size":"1rem"}
}, null, -1)
const _hoisted_14 = { class: "row col-md-11" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "To make your account secure, you are required to change your password immediately to replace the temporary password you were given.")
], -1)
const _hoisted_16 = { class: "col-md-12 d-flex" }
const _hoisted_17 = { class: "col-md-8 pe-2" }
const _hoisted_18 = { class: "row mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "New Password:")
], -1)
const _hoisted_20 = { class: "col-md-7" }
const _hoisted_21 = { class: "row mb-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Confirm Password:")
], -1)
const _hoisted_23 = { class: "col-md-7" }
const _hoisted_24 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_25 = {
  key: 1,
  class: "col-md-7 p-error"
}
const _hoisted_26 = { class: "col-md-4 ps-2" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-password-policy-title" }, "Password Policy:", -1)
const _hoisted_31 = { class: "pl-2 ml-2 mt-0 col-form-password-policy" }
const _hoisted_32 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNotice = _resolveComponent("TheNotice")!
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Password = _resolveComponent("Password")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheNotice),
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-6",
                      key: notification.items
                    }, [
                      _createVNode(_component_Card, null, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notification.title), 1)
                        ]),
                        content: _withCtx(() => [
                          (notification.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notification.items, (item) => {
                                  return (_openBlock(), _createElementBlock("div", { key: item }, [
                                    _createVNode(_component_Skeleton, {
                                      width: "50%",
                                      height: "1.5rem",
                                      class: "mb-2"
                                    }),
                                    _createVNode(_component_Skeleton, {
                                      height: "2rem",
                                      class: "mb-2"
                                    })
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (!notification.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notification.items, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.count
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["p-card-subtitle p-card-subtitile-notification", item.class])
                                    }, [
                                      _createTextVNode(_toDisplayString(item.subtitle) + " ", 1),
                                      (notification.title == 'Publications' && !item.isClosed)
                                        ? (_openBlock(), _createBlock(_component_Badge, {
                                            key: 0,
                                            class: _normalizeClass(["ml-2", 'p-badge-success']),
                                            value: 'Active'
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 2),
                                    (notification.title == 'Follow-Ups')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                          _createElementVNode("p", null, [
                                            _createTextVNode("There are "),
                                            _createVNode(_component_Button, {
                                              class: "p-button-link ps-0 pe-0 pt-0 pb-0",
                                              label: item.count.toString(),
                                              onClick: ($event: any) => (_ctx.viewNotification(item.url, item.status))
                                            }, null, 8, ["label", "onClick"]),
                                            _createTextVNode(" " + _toDisplayString(item.subtitle), 1),
                                            (item.type == 'RPK')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " from " + _toDisplayString(item.companyCount) + " company(ies)", 1))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(".")
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (notification.title == 'Publications')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          _hoisted_13,
                                          _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("p", null, _toDisplayString(_ctx.formatToDayMonthYear(item.lastModifiedDate)) + " " + _toDisplayString(_ctx.formatToDateTime(item.lastModifiedDate).substring(10)), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: 'Reset Password',
      visible: _ctx.isResetPassword,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isResetPassword) = $event)),
      style: {width: '50vw'},
      draggable: false,
      closable: false,
      modal: true,
      dismissableMask: false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          (_ctx.isResetPasswordLoading)
            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "Logout",
            icon: "pi pi-sign-out",
            onClick: _ctx.logout
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm me-0",
            label: "Confirm",
            icon: "pi pi-check",
            onClick: _ctx.resetPassword,
            disabled: _ctx.v$.password.$invalid || _ctx.v$.confirmPassword.$invalid
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Password, {
                    strongRegex: _ctx.strongRegex,
                    class: _normalizeClass({'p-invalid': (_ctx.passwordNotMatch || _ctx.v$.password.$invalid) && _ctx.password != ''}),
                    toggleMask: "",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                  }, null, 8, ["strongRegex", "class", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Password, {
                    strongRegex: _ctx.strongRegex,
                    modelValue: _ctx.confirmPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                    inputClass: {'p-invalid': (_ctx.passwordNotMatch || _ctx.v$.confirmPassword.$invalid)  && _ctx.confirmPassword != ''},
                    toggleMask: ""
                  }, null, 8, ["strongRegex", "modelValue", "inputClass"])
                ]),
                (_ctx.passwordNotMatch)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                  : _createCommentVNode("", true),
                (_ctx.passwordNotMatch)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_25, "Passwords do not matched."))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("ul", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordPolicy, (policies) => {
                        return (_openBlock(), _createElementBlock("li", { key: policies }, _toDisplayString(policies), 1))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}